import React from 'react';
import { Settings2, Webhook, FileSpreadsheet, Workflow, Key, Code, Smartphone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function WhatsAppIntegrations() {
  const navigate = useNavigate();

  const integrations = [
    {
      id: 'api-keys',
      name: 'API Keys',
      description: 'Generate keys to authenticate backend systems with our public WhatsApp REST API.',
      icon: <Key className="w-8 h-8 text-wa-green" />,
      action: () => navigate('/whatsapp/settings'),
      actionLabel: 'Manage Keys',
      status: 'active'
    },
    {
      id: 'webhooks',
      name: 'Outbound Webhooks',
      description: 'Push real-time events (messages, status updates, assignment changes) to your servers.',
      icon: <Webhook className="w-8 h-8 text-blue-500" />,
      action: () => navigate('/whatsapp/settings'),
      actionLabel: 'Configure',
      status: 'active'
    },
    {
      id: 'widget',
      name: 'Web Chat Widget',
      description: 'Embed a WhatsApp chat button on your website. Captures the referring page.',
      icon: <Code className="w-8 h-8 text-purple-500" />,
      action: () => navigate('/whatsapp/settings'),
      actionLabel: 'Get Snippet',
      status: 'active'
    },
    {
      id: 'google-sheets',
      name: 'Google Sheets',
      description: 'Use our Public API via Apps Script to trigger broadcasts directly from a spreadsheet.',
      icon: <FileSpreadsheet className="w-8 h-8 text-emerald-500" />,
      action: () => window.open('https://developers.google.com/apps-script', '_blank'),
      actionLabel: 'View Recipe',
      status: 'recipe'
    },
    {
      id: 'zapier',
      name: 'Zapier / Make',
      description: 'Connect thousands of apps. Create a "Custom Webhook" in Zapier and point it to our API endpoints.',
      icon: <Workflow className="w-8 h-8 text-orange-500" />,
      action: () => window.open('https://zapier.com', '_blank'),
      actionLabel: 'View Recipe',
      status: 'recipe'
    },
    {
      id: 'hubspot',
      name: 'HubSpot',
      description: 'Sync contacts and log WhatsApp conversations directly in HubSpot CRM.',
      icon: <Settings2 className="w-8 h-8 text-orange-600" />,
      action: () => {},
      actionLabel: 'Coming Soon',
      status: 'coming_soon'
    },
    {
      id: 'shopify',
      name: 'Shopify',
      description: 'Send order confirmations, shipping updates, and abandoned cart recovery via WhatsApp.',
      icon: <Smartphone className="w-8 h-8 text-green-600" />,
      action: () => {},
      actionLabel: 'Coming Soon',
      status: 'coming_soon'
    }
  ];

  return (
    <div className="flex-1 flex flex-col h-full overflow-hidden bg-wa-bg p-6">
      <div className="max-w-6xl mx-auto w-full">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-white mb-2">Integrations</h1>
          <p className="text-gray-400">
            Connect AmaPlayer WhatsApp with your existing tools, CRM, and internal systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {integrations.map((app) => (
            <div key={app.id} className="bg-wa-surface border border-wa-border rounded-xl p-6 flex flex-col hover:border-slate-600 transition-colors">
              <div className="flex items-start justify-between mb-4">
                <div className="p-3 bg-wa-surface2 rounded-lg">
                  {app.icon}
                </div>
                {app.status === 'recipe' && (
                  <span className="px-2 py-1 bg-blue-900/30 text-blue-400 text-xs font-medium rounded">Recipe</span>
                )}
                {app.status === 'coming_soon' && (
                  <span className="px-2 py-1 bg-slate-800 text-gray-400 text-xs font-medium rounded">Soon</span>
                )}
              </div>
              
              <h3 className="text-lg font-medium text-white mb-2">{app.name}</h3>
              <p className="text-sm text-gray-400 mb-6 flex-1">
                {app.description}
              </p>
              
              <button
                onClick={app.action}
                disabled={app.status === 'coming_soon'}
                className={`w-full py-2 px-4 rounded-lg font-medium transition-colors ${
                  app.status === 'active' 
                    ? 'bg-wa-surface2 text-white hover:bg-slate-700 border border-wa-border'
                    : app.status === 'recipe'
                    ? 'bg-transparent text-wa-green hover:bg-wa-surface2 border border-wa-green'
                    : 'bg-transparent text-gray-600 border border-slate-800 cursor-not-allowed'
                }`}
              >
                {app.actionLabel}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
